<script setup>
import {onMounted, reactive} from 'vue'
import {State} from '@/paks/vu-app'

const emit = defineEmits(['update:modelValue'])

const page = reactive({
    displays: [],
    displayName: null,
})

onMounted(() => {
    page.displays = State.app.fullDisplay.displays || []
    page.displayName = State.context.name || State.app.display.name
})

function changeDisplay() {
    emit('update:modelValue', page.displayName)
}
</script>

<template>
    <div class="select-display">
        <v-sheet v-if="page.displays.length > 0" class="display-select" :class="State.app.mobile ? 'mobile' : ''">
            <vu-input
                v-model="page.displayName"
                label="Show Pages for Display"
                type="select"
                item-title="name"
                item-value="name"
                :items="page.displays"
                :cols="4" 
                @update:modelValue="changeDisplay"
            />
        </v-sheet>
    </div>
</template>

<style>
.select-display {
    .display-select {
        display: flex;
        padding: 16px 20px 16px 20px;
        margin: 10px 0 10px 0;
        border: 1px solid rgb(var(--v-theme-border)) !important;
    }
    .display-select.mobile {
        padding: 12px 10px 0px 10px;
    }
}
</style>